// extracted by mini-css-extract-plugin
module.exports = {"buttons":"wr9vlRJzu-ZK8lJVl59P"};